import React from "react";
import { InventoryProductDetailsByFileOut } from "api-client";
import FilesTable from "components/FileUploader/FilesTable";
import { FIELDSSET_TITLE_CLASSES } from "features/MappingEditor/consts";
import { useTranslation } from "react-i18next";

const OwnDocuments = ({
  details,
}: {
  details: InventoryProductDetailsByFileOut;
}) => {
  const { t } = useTranslation();

  if (!details?.files_info?.documents?.length) return;
  return (
    <div className="py-4 border-b border-gray-200">
      <div className={FIELDSSET_TITLE_CLASSES}>
        {t("mapping.ownDocumentsFull")}
      </div>
      <FilesTable uploadedFiles={details?.files_info?.documents} />
    </div>
  );
};

export default OwnDocuments;
